import mimaPayLogo from './mimapay logo.png';
import mimaPayLogoWhite from './mimapay logo white.png';

export { mimaPayLogo, mimaPayLogoWhite };
